import Image from 'next/image';
import Stores from './Stores';

const ReviewScore = () => (
  <div className="flex flex-col items-center gap-2">
    <div className="flex items-center gap-1 mb-1">
      <span className="text-xl">
        <strong>+100 mil</strong> reseñas <strong>4.9</strong>
      </span>
      <Image src="/icons/star_premium.svg" alt="star" width={16} height={16} />
    </div>
    <Stores size="large" />
  </div>
);

export default ReviewScore;
